<template>
  <v-container id="uploadCenter">
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="10" md="6" class="pb-0">
        <p class="headline font-weight-light">App Version</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" v-if="progress != 100" class="pa-4">
        <v-progress-linear
        color="light-blue"
        height="10"
        :value="progress"
        striped
        ></v-progress-linear>
      </v-col>
    </v-row>

    <v-form>
      <v-row justify="center" align="center">
        <v-col cols="12" xs="12" sm="10" md="6">
          <v-row>
            <v-col cols="6" class="py-0">
              <v-text-field
              label="Name"
              clearable
              height="56"
              outlined
              v-model="formData.name"
              dense
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-select
              outlined
              v-model="formData.isDefault"
              :items="statusList"
              item-text="title"
              item-value="key"
              label="Als Standard"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0">
              <v-text-field
              label="Kommentar"
              clearable
              height="56"
              outlined
              v-model="formData.comment"
              dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-4 text-right">
              <v-btn @click="downloadItem()" small color="grey" class="text-none" outlined>Download</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0">
              <v-btn @click="cancelItem()" small color="grey" class="text-none" outlined>Abbrechen</v-btn>
            </v-col>
            <v-col cols="6" class="py-0 text-right">
              <v-btn @click="updateItem()" small color="green" class="text-none" outlined elevation="3">Speichern
              </v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </v-form>


  </v-container>
</template>

<script>
import Vue from 'vue'
import swal from 'sweetalert2'

export default {
  name: 'AppsDefault',
  components: {},
  data () {
    return {
      statusList: [
        {
          key: 0,
          title: 'Nein'
        },
        {
          key: 1,
          title: 'Ja'
        }
      ],
      guid: 0,
      formData: {
        name: '',
        screenNumber: '',
        owner: '',
        playlist: '',
        phone: '',
        create: '',
        changed: ''
      },
      progress: 100,
      uploadConfig: {
        uploadUrl: '',
        jQueryDivName: '#uploadCenter'
      }
    }
  },
  methods: {
    onGetData: function (data) {
      console.log('deviceGuid', data)
      this.formData = data
      this.uploadConfig.uploadUrl = Vue.prototype.$config.HOST + '/v1/apps/upload/' + this.formData.name
      this.uploadConfig.onUploadProgress = this.onUploadProgress
      this.uploadConfig.onUploadSuccess = this.onUploadSuccess
      this.initDragAndDrop(this.uploadConfig, Vue.prototype.$eventHub)
    },
    onItemUpdated: function (data) {
      console.log('onItemUpdated', data)
      this.cancelItem()
    },
    cancelItem: function () {
      this.$router.push('/Dashboard/Apps')
    },
    downloadItem: function () {
      window.open(Vue.prototype.$config.HOST + '/apps/' + this.formData.name + '/player.apk', '_new')
    },
    updateItem: function () {
      Vue.prototype.$api.updateApps(this.guid, this.formData, this.onItemUpdated)
    },
    onUploadProgress: function (id, percent) {
      console.log(id, percent)
      this.progress = percent
    },
    onUploadSuccess (data) {
      console.log('upload done', data)
      // this.$refs.table.reload(this.guid)
    },
    initDragAndDrop (config, eventHub) {
      console.log('init drag and drop', config)
      config.eventHub = eventHub
      var cmp = this
      window.jQuery(config.jQueryDivName).dmUploader({
        url: function () {
          return config.uploadUrl
        },
        fileName: 'files',
        dataType: 'json',
        headers: {},
        allowedTypes: '*',
        /* extFilter: 'jpg;png;gif', */
        onInit: function () {
          console.log('onInit uploader')
        },
        onBeforeUpload: function (id) {
          // updateFileStatus(id, 'uploading', 'Uploading...')
          console.log(id)
          config.eventHub.$emit('lockScreen')
        },
        onNewFile: function (id, file) {
          config.eventHub.$emit('unlockScreen')
          console.log(id, file)
        },
        onComplete: function () {
          console.log('upload complete')
          config.eventHub.$emit('unlockScreen')
        },
        onUploadProgress: function (id, percent) {
          if (config.onUploadProgress) config.onUploadProgress(id, percent)
          cmp.$eventHub.$emit('uploadProgess', percent)
        },
        onUploadSuccess: function (id, data) {
          if (config.onUploadSuccess) config.onUploadSuccess(id, data)
          cmp.$eventHub.$emit('unlockScreen')
        },
        onUploadError: function (id, message) {
          cmp.$eventHub.$emit('unlockScreen')
          swal('Upload Fehler', id + ' - ' + message, 'error')
        },
        onFileTypeError: function (file) {
          console.log('file', file)
        },
        onFileSizeError: function (file) {
          console.log('file', file)
        },
        onFileExtError: function (file) {
          console.log('file', file)
        },
        onFallbackMode: function (message) {
          swal(
          'Upload Fehler',
          'Browser not supported(do something else here!): ' + message,
          'error'
          )
        }
      })
    }
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
    this.guid = this.$route.params.guid
    Vue.prototype.$api.loadApp(this.guid, this.onGetData)
  }
}
</script>

<style scoped>

</style>
